document.addEventListener('DOMContentLoaded', () => {
  const collectionsNavigationSelect = document.querySelector('[data-collections-navigation-select]');

  if (collectionsNavigationSelect) {
    collectionsNavigationSelect.addEventListener('change', (e) => {
      const value = e.target.value;
      if (!value) return;
      window.location.hash = value;
    });
  }

  document.querySelectorAll('[data-featured-collection-list-section]').forEach((section) => {
    const sectionId = section.dataset.featuredCollectionListSection;
    const feturedListModal = document.getElementById('featuredListModal-' + sectionId);
    const featuredListModalTriger = document.getElementById('featuredListModalTriger-' + sectionId);
    const featuredListModalClose = document.getElementById('featuredListModalClose-' + sectionId);

    if (featuredListModalTriger && feturedListModal) {
      featuredListModalTriger.addEventListener('click', () => {
        feturedListModal.showModal();
      });
    }

    if (featuredListModalClose && feturedListModal) {
      featuredListModalClose.addEventListener('click', () => {
        feturedListModal.close();
      });
    }
  });
});
